// Utility to calculate the mean (average)
export const mean = (data) => {
  const sum = data.reduce((acc, val) => acc + val, 0);
  return sum / data.length;
};

// Utility to calculate the standard deviation
export const standardDeviation = (data) => {
  const dataMean = mean(data);
  const squaredDiffs = data.map((value) => (value - dataMean) ** 2);
  const avgSquaredDiff = mean(squaredDiffs);
  return Math.sqrt(avgSquaredDiff);
};

// Function to generate normal distribution data based on mean and standard deviation
export const generateNormalDistribution = (mean, stdDev, numPoints = 100) => {
  const distribution = [];
  const step = (stdDev * 4) / numPoints; // A range of 4 standard deviations on either side
  for (let i = -2 * stdDev; i <= 2 * stdDev; i += step) {
    // Normal distribution formula
    const x = (1 / (stdDev * Math.sqrt(2 * Math.PI))) * Math.exp(-0.5 * (i / stdDev) ** 2);
    distribution.push({ x, y: i + mean });
  }
  return distribution;
};

export const formatEnum = (value) => {
  if (!value) return "";
  // Replace underscores with spaces, lowercase everything, then capitalize each word
  return value
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
